<work-experience-details-library (onDialogClose)="handleDialogClose()" [primaryData]="primaryData" style="width:100%">
</work-experience-details-library>